import { sendAddToCart, fetchCartData } from "../helpers/cart";

export interface IFreeGift extends HTMLElement {
  freeGiftProduct: string | null;
  addToCartButton: HTMLButtonElement | null;
  cartValue: string | number | Promise<string> | null;
  threshold: string | null;
  freeGiftText: HTMLParagraphElement | null;
  freeGiftTitleThreshold: HTMLHeadingElement | null;
  freeGiftTitle: HTMLHeadingElement | null;
  cartData: {
    items:
      | {
          id: string | null;
        }[]
      | undefined;
    items_subtotal_price?: string | number;
  };
}

class FreeGift extends HTMLElement implements IFreeGift {
  public freeGiftProduct: string | null = null;
  public threshold: string | null = null;
  public thresholdPrice: number | null = null;
  public addToCartButton: HTMLButtonElement | null = null;
  public freeGiftText: HTMLParagraphElement | null = null;
  public freeGiftTitleThreshold: HTMLHeadingElement | null = null;
  public freeGiftTitle: HTMLHeadingElement | null = null;
  public cartValue: string | number | Promise<string> | null = null;
  public cartData: {
    items:
      | {
          id: string | null;
        }[]
      | undefined;
    items_subtotal_price?: string | number;
  } = { items: undefined };

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeElements();
    this.getCartValue();
    document.addEventListener("cart:updated", this.getCartValue.bind(this));
  }

  public initializeElements() {
    this.addToCartButton =
      this.querySelector<HTMLButtonElement>("[data-add-to-cart]");
    this.freeGiftText =
      this.querySelector<HTMLParagraphElement>(".free-gift__text");
    this.freeGiftTitleThreshold = this.querySelector<HTMLHeadingElement>(
      ".free-gift__title-threshold",
    );
    this.freeGiftTitle =
      this.querySelector<HTMLHeadingElement>(".free-gift__title");
  }

  public async getFreeGiftProduct() {
    this.freeGiftProduct = this.getAttribute("free-gift-product");
  }

  public async getThreshold() {
    this.thresholdPrice =
      parseInt(this.getAttribute("data-threshold") ?? "0") * 100;
  }

  public async getCartValue() {
    const cartData = await fetchCartData();
    this.cartData = cartData;
    this.cartValue = cartData.items_subtotal_price || null;
    await this.getFreeGiftProduct();
    await this.getThreshold();
    this.updateUI();
  }

  public updateUI() {
    this.setButton();
    this.setText();
    this.handleAddToCart();
  }

  public setText() {
    const item = this.cartData.items?.find(
      (item: { id: string | null }) => item.id == this.freeGiftProduct,
    );

    if (item) {
      this.toggleDisplay(this, "none");
    } else if (
      this.cartValue !== null &&
      this.thresholdPrice !== null &&
      Number(this.cartValue) >= this.thresholdPrice &&
      !item
    ) {
      this.toggleDisplay(this.freeGiftText, "none");
      this.toggleDisplay(this.freeGiftTitleThreshold, "none");
      this.toggleDisplay(this.freeGiftTitle, "block");
    } else {
      this.toggleDisplay(this.freeGiftText, "block");
      this.toggleDisplay(this.freeGiftTitleThreshold, "block");
      this.toggleDisplay(this.freeGiftTitle, "none");
    }
  }

  public setButton() {
    const item = this.cartData.items?.find(
      (item: { id: string | null }) => item.id == this.freeGiftProduct,
    );

    this.style.display = item ? "none" : "block";
    if (
      !item &&
      this.thresholdPrice !== null &&
      this.cartValue !== null &&
      Number(this.cartValue) >= this.thresholdPrice
    ) {
      this.toggleDisplay(this.addToCartButton, "block");
    } else {
      this.toggleDisplay(this.addToCartButton, "none");
    }
  }

  public toggleDisplay(element: HTMLElement | null, displayValue: string) {
    if (element) {
      element.style.display = displayValue;
    }
  }

  public handleAddToCart() {
    if (!this.addToCartButton) return;
    this.addToCartButton.addEventListener("click", async () => {
      const freeGiftProduct = {
        id: this.freeGiftProduct || "",
        quantity: 1,
        properties: { free_gift: "true" },
        selling_plan: "",
      };
      await sendAddToCart([freeGiftProduct]);
    });
  }
}

customElements.define("uwp-free-gift", FreeGift);
